import { makeStyles } from '@material-ui/core'

// Mesmo tratamento do preview do fluxo de modelos automatizados (GenerateDocumentStep): apenas o
// contêiner de rolagem e a normalização de fonte que o JoditEditor.Preview já espera.
//
// Nada aqui mexe em títulos, margens, escala tipográfica ou alinhamento: o conteúdo vem como foi
// escrito no editor e o preview precisa mostrar o documento com a aparência original dele.
const styles = makeStyles((theme) => ({
  previewPaper: {
    backgroundColor: theme.palette.white,
  },
  previewBoxContainer: {
    maxHeight: 360,
    overflowY: 'auto',
    position: 'relative',
  },
  previewBox: {
    fontSize: '16px',
    fontFamily: 'Arial, sans-serif !important',
    lineHeight: 1.5,

    '& *': {
      fontFamily: 'Arial, sans-serif !important',
      color: 'initial',
    },
  },
}))

export default styles
